/** Height of `Layout` top bar (px); keep quote/login layouts in sync. */
export const APP_TOP_NAV_HEIGHT_PX = 56;
